import { useEffect, useState } from "react";
import axios from "axios";
import { Loader2, Mail, Clock, AlertTriangle, CheckCircle2, ExternalLink } from "lucide-react";
import { fileUrl } from "../lib/api";

const ST = {
  sent: { label: "وصل", cls: "bg-emerald-50 text-emerald-700", icon: CheckCircle2 },
  pending: { label: "في الانتظار", cls: "bg-amber-50 text-amber-700", icon: Clock },
  failed: { label: "تعذّر الإرسال", cls: "bg-rose-50 text-rose-700", icon: AlertTriangle },
};

export const EmployeeEmailLog = ({ employeeId }) => {
  const [items, setItems] = useState(null);
  useEffect(() => {
    axios.get(`${process.env.REACT_APP_BACKEND_URL}/api/employees/${employeeId}/email-log`).then((r) => setItems(r.data.items)).catch(() => setItems([]));
  }, [employeeId]);
  if (!items) return <div className="py-8 text-center"><Loader2 className="mx-auto h-5 w-5 animate-spin text-slate-400" /></div>;
  if (!items.length) return <p className="py-8 text-center text-sm text-slate-400" data-testid="emp-email-log-empty">ما انرسل لهذا الموظف أي مستند بالإيميل للحين</p>;
  return (
    <div className="space-y-2" data-testid="emp-email-log">
      {items.map((x) => {
        const s = ST[x.status] || ST.sent;
        return (
          <div key={x.id} className="flex flex-wrap items-center gap-3 rounded-xl border border-slate-200 bg-white p-3" data-testid={`emp-email-log-${x.id}`}>
            <Mail className="h-4 w-4 shrink-0 text-blue-600" />
            <div className="min-w-0 flex-1">
              <p className="truncate text-sm font-semibold text-slate-800">{x.title}</p>
              <p className="text-xs text-slate-500"><span dir="ltr">{x.to}</span> · {new Date(x.at).toLocaleString("ar-SA-u-ca-gregory-nu-latn", { timeZone: "Asia/Riyadh", dateStyle: "medium", timeStyle: "short" })}{x.by ? ` · بواسطة ${x.by}` : ""}</p>
            </div>
            <span className={`inline-flex items-center gap-1 rounded-full px-2 py-0.5 text-xs font-semibold ${s.cls}`}><s.icon className="h-3 w-3" /> {s.label}</span>
            {x.file_id && <a href={fileUrl(x.file_id)} target="_blank" rel="noreferrer" className="inline-flex items-center gap-1 text-xs text-blue-600 hover:underline"><ExternalLink className="h-3.5 w-3.5" /> الملف</a>}
          </div>
        );
      })}
    </div>
  );
};
